module.exports = __webpack_public_path__ + "media/images/lp-fukushima12/kv_bg_pc_3@2x-8e1682501f9574364cdf3a5b8671173e.jpg";